
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../index';
import { ApiUrl } from '../../../Network/ApiUrl';
import { get } from '../../../Network/ApiService';

interface FetchAppointmentDataArgs {
    user_id: string;
    from_date_time:string;
    to_date_time:string;
    type:string;
    authToken: string;
}

// Define the return type for the Thunk action
interface AppointmentData {
    message: string;
    userData: any; // Adjust the type of userData to match your data structure
}

// Create the Thunk action
export const fetchAppointmentData = createAsyncThunk<AppointmentData, FetchAppointmentDataArgs, { state: RootState }>(
    'appointment/fetchAppointmentData',
    async ({ user_id,from_date_time,to_date_time,type, authToken }, { dispatch }) => {
        try {
            let ApiEndPoint;
            if(type === 'provider'){
                ApiEndPoint = `${ApiUrl.appointments.get_provider_appointments}?provider_id=${user_id}&from_date_time=${from_date_time}&to_date_time=${to_date_time}`;
            }else{
                ApiEndPoint = `${ApiUrl.appointments.get_patient_appointments}?patient_id=${user_id}&from_date_time=${from_date_time}&to_date_time=${to_date_time}`;
            }

            const response = await get(ApiEndPoint, authToken);
            if (response) {               
                return response.data;
            } else {
                throw new Error('Failed to fetch patient profile data');
            }
        } catch (error) {
            throw error; // This will trigger the rejected action
        }
    }
);
